"use client";

import { ShoppingCart } from "lucide-react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import CartDrawer from "./CartDrawer";
import { useCartStore } from "@/app/store/cartStore";

interface CartButtonProps {
  onOpenChange?: (open: boolean) => void;
}

export default function CartButton({ onOpenChange }: CartButtonProps = {}) {
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const totalItems = useCartStore((state) => state.getTotalItems());

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    onOpenChange?.(open);
  };

  return (
    <>
      {/* Cart Button */}
      <motion.button
        onClick={() => handleOpenChange(true)}
        className="relative w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-card backdrop-blur-xl border border-border flex items-center justify-center text-heading shadow-sm hover:bg-muted transition-all"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Shopping cart"
      >
        <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6" />

        {/* Badge with item count - rendered after mount to avoid hydration mismatch */}
        {mounted && totalItems > 0 && (
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary text-white text-xs font-bold rounded-full flex items-center justify-center shadow-lg">
            {totalItems > 99 ? "99+" : totalItems}
          </div>
        )}
      </motion.button>

      {/* Cart Drawer */}
      <CartDrawer isOpen={isOpen} onClose={() => handleOpenChange(false)} />
    </>
  );
}

// "use client";

// import { ShoppingCart } from "lucide-react";
// import { motion } from "framer-motion";
// import { useState, useEffect } from "react";
// import CartDrawer from "./CartDrawer";
// import { useCartStore } from "@/app/store/cartStore";

// export default function CartButton() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [mounted, setMounted] = useState(false);
//   const totalItems = useCartStore((state) => state.getTotalItems());

//   useEffect(() => {
//     setMounted(true);
//   }, []);

//   return (
//     <>
//       {/* Cart Button */}
//       <motion.button
//         onClick={() => setIsOpen(true)}
//         className="relative w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-card backdrop-blur-xl border border-border flex items-center justify-center text-heading shadow-sm hover:bg-muted transition-all"
//         whileHover={{ scale: 1.05 }}
//         whileTap={{ scale: 0.95 }}
//         aria-label="Shopping cart"
//       >
//         <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6" />

//         {/* Badge with item count - rendered after mount to avoid hydration mismatch */}
//         {mounted && totalItems > 0 && (
//           <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary text-white text-xs font-bold rounded-full flex items-center justify-center shadow-lg">
//             {totalItems > 99 ? "99+" : totalItems}
//           </div>
//         )}
//       </motion.button>

//       {/* Cart Drawer */}
//       <CartDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
//     </>
//   );
// }
